import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  treeShake: true,
  customVariables: ['@/assets/variables.scss'],
  breakpoint: {
    thresholds: {
      xs: 300,
      sm: 476,
      md: 668,
      lg: 1000,
      xl: 1300
    },
    scrollBarWidth: 24,
  },
  icons: {
      iconfont: 'mdi',
      values: {},
  },
  rtl: false,
  theme: {
    dark: true,
    default: 'dark',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: undefined,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: {
      dark: {
        blue: "#1F98FF",
        primary: "#1F98FF",
        secondary: "#111",
        accent: "#95be00",
        atoAppBar: '#30363C',
        atoNavBar: '#111',
        atoLightBlue: '#798086',
        atoDarkBlue: '#111',
        atoDarkBg: '#111',
        atoDarkBg2: '#111',
        error: '#FF5252',
        info: '#bbdb45',
        success: '#4CAF50',
        warning: '#FB8C00',
        anchor: '#8c9eff'
      }
    }
  }
});
